<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83334 12.4997L10 16.6663L14.1667 12.4997M5.83334 7.49967L10 3.33301L14.1667 7.49967"
      stroke="white"
      stroke-opacity="0.5"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

